import Vue from 'vue';
import anime from 'animejs';

Vue.prototype.$anime = anime;
